import React, { Fragment, useEffect, useState } from "react";
import { Seo, Breadcrumb, ScrollTopBtn, TitleWrap } from "../components";
import { HeaderTwo, FooterTwo } from "../containers";

/**
 * CookiePolicy page (TH + EN)
 * - Mirrors PrivacyPolicy structure
 * - SSR-safe access to localStorage
 * - Listens to `storage` for cross-tab language changes (key: cheese_lang)
 */

const getInitialLang = () => {
  if (typeof window === "undefined") return "th";
  return window.localStorage.getItem("cheese_lang") || "th";
};

const CookiePolicy = () => {
  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const v = window.localStorage.getItem("cheese_lang");
      setLang(v || "th");
    }
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const onStorage = () => {
      const v = window.localStorage.getItem("cheese_lang");
      setLang(v || "th");
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const isTH = lang === "th";

  return (
    <Fragment>
      <Seo title={isTH ? "นโยบายคุกกี้" : "Cookie Policy"} />
      <HeaderTwo />
      <Breadcrumb pageName={isTH ? "นโยบายคุกกี้" : "Cookie Policy"} bgImage="images/miw/bar_008.jpg" />

      <div className="container mb-100px">
        <TitleWrap className="text-center">
          <div className="d-flex justify-content-center pt-60px">
            <h1 className="title-line">{isTH ? "นโยบายคุกกี้ (Cookie Policy)" : "Cookie Policy"}</h1>
          </div>
        </TitleWrap>

        {isTH ? <ThaiCookie /> : <EnglishCookie />}
      </div>

      <FooterTwo />
      <ScrollTopBtn />
    </Fragment>
  );
};

export default CookiePolicy;

/** ================= Thai Cookie Policy ================= */
const ThaiCookie = () => (
  <div className="row gx-60 gy-2">
    <div className="col-12">
      <section className="mb-4">
        <h2 className="h4">นโยบายคุกกี้ (Cookie Policy)</h2>
        <p>
          เว็บไซต์นี้ให้บริการโดยบริษัท ชีส ดิจิตอล เน็ตเวิร์ค จำกัด (“บริษัท”) เว็บไซต์นี้ใช้คุกกี้และเครื่องมืออื่นเพื่อช่วยแยกแยะรูปแบบการใช้งานเว็บไซต์ของท่านจากผู้ใช้งานอื่นๆ ซึ่งจะช่วยให้ท่านได้รับประสบการณ์ที่ดีจากการใช้งานเว็บไซต์ และช่วยให้บริษัทสามารถพัฒนาคุณภาพของเว็บไซต์ให้ดียิ่งขึ้น
        </p>
        <p>
          นโยบายคุกกี้นี้จะอธิบายถึงความหมาย การทำงาน วัตถุประสงค์ รวมถึงการลบและการปฏิเสธการเก็บคุกกี้เพื่อความเป็นส่วนตัวของท่าน โดยการเข้าสู่เว็บไซต์นี้ถือว่าท่านได้อนุญาตให้บริษัทใช้คุกกี้ตามนโยบายคุกกี้ที่มีรายละเอียดดังต่อไปนี้
        </p>
      </section>

      <section className="mb-4">
        <h3 className="h5">คุกกี้ (Cookies) คืออะไร</h3>
        <p>
          คุกกี้ คือ ไฟล์ขนาดเล็กที่เก็บไว้บนเบราว์เซอร์ของผู้ใช้บริการ หรือบนฮาร์ดไดร์ฟในคอมพิวเตอร์ หรืออุปกรณ์มือถือของผู้ใช้บริการ ซึ่งทำหน้าที่บันทึกข้อมูลและการตั้งค่าต่าง ๆ เช่น บันทึกข้อมูลการตั้งค่าภาษาในเบราว์เซอร์บนอุปกรณ์ของผู้ใช้บริการ บันทึกสถานะการเข้าใช้งานในปัจจุบันของผู้ใช้บริการ เพื่อช่วยให้ผู้ใช้บริการสามารถเข้าใช้งานเว็บไซต์ได้อย่างต่อเนื่อง รวมถึงมีการรวบรวมข้อมูลเกี่ยวกับประวัติการเข้าชมเว็บไซต์ที่ผู้ใช้บริการชื่นชอบในรูปแบบไฟล์ โดยคุกกี้ไม่ได้ทำให้เกิดอันตรายต่ออุปกรณ์ของคุณ และเนื้อหาในคุกกี้จะถูกเรียกออกมาดูหรืออ่านได้โดยเว็บไซต์ที่สร้างคุกกี้ดังกล่าวเท่านั้น คุณสามารถยอมรับหรือปฏิเสธการใช้งานคุกกี้ได้โดยการปรับการตั้งค่าในเบราว์เซอร์ของคุณ หากคุณต้องการทำเช่นนี้ โปรดดูที่เมนูช่วยเหลือของเบราว์เซอร์ของคุณ
        </p>
        <p>
          ข้อมูลที่เราได้รับผ่านคุกกี้และเทคโนโลยีที่คล้ายคลึงกัน ในที่นี้ยังอาจรวมถึง IP address ของคุณ รหัสโฆษณาบนมือถือ คุณลักษณะของเบราว์เซอร์ คุณลักษณะอุปกรณ์ รหัสอุปกรณ์เฉพาะ ระบบปฏิบัติการ การตั้งค่าภาษา การอ้างอิง URL บันทึกพฤติกรรมบนเว็บไซต์ของคุณ อย่างเช่นเนื้อหาที่ผู้ใช้บริการเข้าชมหรือสนใจขณะที่ทำการเยี่ยมชมเว็บไซต์นั้น ๆ รวมถึงวันที่และเวลาที่ผู้ใช้บริการเข้าถึงหรือใช้งานเว็บไซต์ ในการเชื่อมต่อแอพบนมือถือและแท็บเล็ตเราอาจใช้วิธีการอัตโนมัติที่คล้ายกันด้วย
        </p>
      </section>

      <section className="mb-4">
        <h3 className="h5">บริษัทใช้คุกกี้อย่างไร</h3>
        <p>
          บริษัทจะจัดเก็บข้อมูลการเข้าเยี่ยมชมเว็บไซต์ จากผู้เข้าเยี่ยมชมทุกรายผ่านคุกกี้ หรือเทคโนโลยีที่ใกล้เคียง และบริษัทจะใช้คุกกี้เพื่อประโยชน์ในการพัฒนาประสิทธิภาพในการเข้าถึงบริการของบริษัทผ่านอินเทอร์เน็ต รวมถึงพัฒนาประสิทธิภาพในการใช้งานบริการของบริษัททางอินเทอร์เน็ต ให้สามารถสร้างประสบการณ์ และความพึงพอใจให้ท่าน โดยจะใช้เพื่อกรณี ดังต่อไปนี้
        </p>
        <ol>
          <li>เพื่อให้เจ้าของข้อมูลส่วนบุคคลสามารถ sign in บัญชีของเจ้าของข้อมูลส่วนบุคคลในเว็บไซต์ของบริษัทได้อย่างต่อเนื่อง</li>
          <li>เพื่อศึกษาพฤติกรรมการใช้งานเว็บไซต์ ของเจ้าของข้อมูลส่วนบุคคล เพื่อนำไปพัฒนาให้บริการดิจิทัลของบริษัทสามารถใช้งานได้ง่าย รวดเร็ว และมีประสิทธิภาพยิ่งขึ้น</li>
        </ol>
      </section>

      <section className="mb-4">
        <h3 className="h5">ประเภทของคุกกี้ที่บริษัทใช้</h3>
        <p>บริษัทใช้คุกกี้ดังต่อไปนี้ สำหรับเว็บไซต์ของบริษัท</p>
        <ul>
          <li><strong>คุกกี้ที่มีความจำเป็น (Necessary Cookies)</strong> ที่ต้องใช้เพื่อเปิดใช้งานฟังก์ชั่นหลักของเว็บไซต์ คุกกี้ประเภทนี้ช่วยให้ประสบการณ์การใช้เว็บไซต์ของท่านเป็นไปอย่างต่อเนื่อง เช่น การจดจำการเข้าสู่ระบบ การจดจำข้อมูลที่ท่านให้ไว้บนเว็บไซต์</li>
          <li><strong>คุกกี้เพื่อการทำงานของเว็บไซต์ (Functionality Cookies)</strong> ใช้ในการจดจำตัวท่านเมื่อท่านกลับมาใช้งานเว็บไซต์อีกครั้ง ซึ่งจะช่วยให้บริษัทสามารถปรับแต่งเนื้อหาสำหรับท่าน ปรับให้เว็บไซต์ของบริษัทตอบสนองความต้องการใช้งานของท่าน รวมถึงจดจำการตั้งค่าของท่าน อาทิ ภาษา ภูมิภาค หรือขนาดตัวอักษร</li>
          <li><strong>คุกกี้เพื่อการโฆษณา (Advertising Cookies)</strong> ใช้ในการจดจำสิ่งที่ลูกค้าเคยเยี่ยมชม เพื่อนำเสนอสินค้า บริการ หรือสื่อโฆษณาที่เกี่ยวข้องให้ตรงกับความสนใจของผู้ใช้งาน คุกกี้ประเภทนี้จะบันทึกบนอุปกรณ์ของท่านเพื่อเก็บข้อมูลการเข้าใช้งานและลิงก์ที่ท่านได้เยี่ยมชมและติดตาม อาจมีคุกกี้จากบุคคลที่สามเพื่อช่วยในการปรับแต่งเว็บไซต์และแคมเปญโฆษณาให้เหมาะสม</li>
          <li><strong>คุกกี้ประเภทการวิเคราะห์และวัดผลการทำงาน (Analytics and Performance Cookies)</strong> ช่วยให้บริษัทสามารถวัดผลการทำงาน เช่น จำนวนหน้าที่ท่านเข้าใช้งาน และรูปแบบพฤติกรรมของผู้ใช้งาน เพื่อนำมาวิเคราะห์และพัฒนาประสบการณ์ใช้งาน</li>
        </ul>
      </section>

      <section className="mb-4">
        <h3 className="h5">ระยะเวลาที่คุกกี้จะถูกเก็บไว้ในอุปกรณ์ของคุณ</h3>
        <p>มีคุกกี้ 2 ประเภทที่ถูกจัดเก็บไว้</p>
        <ul>
          <li><strong>คุกกี้แบบช่วงเวลา (Session Cookies)</strong> จะถูกลบโดยอัตโนมัติเมื่อคุณปิดเบราว์เซอร์</li>
          <li><strong>คุกกี้ถาวร (Persistent Cookies)</strong> จะยังคงอยู่ในอุปกรณ์จนกระทั่งหมดอายุหรือถูกลบทิ้ง โดยช่วยจดจำความสนใจของคุณเพื่อให้การเข้าใช้ครั้งถัดไปสะดวกและตรงความต้องการมากขึ้น</li>
        </ul>
      </section>

      <section className="mb-4">
        <h3 className="h5">การจัดการคุกกี้</h3>
        <p>
          ท่านสามารถเลือกตั้งค่าคุกกี้แต่ละประเภท ยกเว้นคุกกี้ที่จำเป็น (Strictly Necessary Cookies) ได้ โดย “การตั้งค่าคุกกี้” หรือการตั้งค่าในเว็บเบราว์เซอร์ เช่น การปิดกั้นการติดตั้งคุกกี้บนอุปกรณ์ของท่าน คู่มือสำหรับเบราว์เซอร์ยอดนิยมมีดังนี้:
        </p>
        <ul>
          <li><a href="https://support.google.com/chrome/answer/95647?hl=th">Chrome</a></li>
          <li><a href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored">Firefox</a></li>
          <li><a href="https://support.microsoft.com/en-us/help/278835/how-to-delete-cookie-files-in-internet-explorer">Internet Explorer</a></li>
          <li><a href="https://support.microsoft.com/en-us/help/4468242/microsoft-edge-browsing-data-and-privacy">Microsoft Edge</a></li>
          <li><a href="https://support.apple.com/en-us/HT201265">Safari</a></li>
          <li><a href="https://support.apple.com/en-us/HT201265">Safari for iOS</a></li>
          <li><a href="https://support.google.com/chrome/answer/95647?hl=th">Chrome for Android</a></li>
          <li><a href="https://support.google.com/chrome/answer/95647?hl=th">Chrome for iOS</a></li>
        </ul>
        <p>การปิดการใช้งานคุกกี้อาจส่งผลให้ท่านไม่สามารถใช้เว็บไซต์บางส่วนได้อย่างมีประสิทธิภาพ</p>
      </section>

      <section className="mb-4">
        <h3 className="h5">การเปลี่ยนแปลงนโยบายคุกกี้</h3>
        <p>
          นโยบายคุกกี้นี้อาจมีการปรับปรุงแก้ไขตามโอกาสเพื่อให้เป็นไปตามกฎระเบียบ ดังนั้น บริษัทขอแนะนำให้ท่านตรวจสอบและทำความเข้าใจการเปลี่ยนแปลงดังกล่าวเป็นระยะ ๆ
        </p>
      </section>

      <section className="mb-4">
        <h3 className="h5">ช่องทางการติดต่อบริษัท</h3>
        <address>
          บริษัท ชีส ดิจิตอล เน็ตเวิร์ค จำกัด<br />
          ที่อยู่: เลขที่ 2521/55-56 ถนนลาดพร้าว แขวงคลองเจ้าคุณสิงห์ เขตวังทองหลาง กรุงเทพมหานคร 10310<br />
          โทรศัพท์: 02-530 0185-6<br />
          อีเมล: <a href="mailto:admin@cheesediginet.com">admin@cheesediginet.com</a>
        </address>
      </section>

      <section className="mt-5">
        <small className="text-muted">ประกาศนโยบายคุกกี้นี้ ปรับปรุงล่าสุดเมื่อ 1 ตุลาคม 2568</small>
      </section>
    </div>
  </div>
);

/** ================= English Cookie Policy ================= */
const EnglishCookie = () => (
  <div className="row gx-60 gy-2">
    <div className="col-12">
      <section className="mb-4">
        <h2 className="h4">Cookie Policy</h2>
        <p>
          This website is operated by Cheese Digital Network Co., Ltd. (“the Company”). This website uses cookies and other tools to help distinguish your usage patterns from those of other users. This allows you to have a better experience while using the website and helps us improve the quality of website even further.
        </p>
        <p>
          This Cookie Policy explains the meaning, functionality, purposes, as well as the methods for deleting and refusing cookies in order to protect your privacy. By accessing this website, you are deemed to have consented to the Company's use of cookies in accordance with the details outlined in this Cookie Policy.
        </p>
      </section>

      <section className="mb-4">
        <h3 className="h5">What are Cookies?</h3>
        <p>
          Cookies are small files that are stored on a user’s browser, computer hard drive, or mobile device. They are used to record information and various settings such as language preferences on the user’s browser or the user’s current login status, allowing for a seamless experience on the website. Cookies may also collect data about the user’s browsing history in the form of files. Cookies do not harm your device, and their contents can only be accessed or read by the website that created them.
        </p>
        <p>
          You can choose to accept or decline the use of cookies by adjusting your browser settings. If you wish to do so, please refer to the help menu of your browser.
        </p>
        <p>
          The information we collect through cookies and similar technologies may include your IP address, mobile advertising ID, browser characteristics, device characteristics, unique device identifiers, operating system, language settings, referring URLs, and behavioral logs of your activity on the website such as the content you viewed or showed interest in during your visit, including the date and time you accessed or used the website. When connecting through mobile apps or tablets, we may use similar automated methods.
        </p>
      </section>

      <section className="mb-4">
        <h3 className="h5">How the Company Uses Cookies</h3>
        <p>
          The Company collects data from every visitor to the website through cookies or similar technologies. Cookies are used to enhance the efficiency of accessing the Company’s services via the internet and to improve the overall user experience when using the Company’s online services. The use of cookies is intended to create a seamless and satisfying experience for you and may be used for the following purposes:
        </p>
        <ul>
          <li>To allow data subjects to sign in to their accounts on the Company’s website continuously without interruption.</li>
          <li>To analyze user behavior on the website in order to improve the usability, speed, and overall efficiency of the Company’s digital services.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h3 className="h5">Types of Cookies Used</h3>
        <p>The Company uses the following types of cookies on its website:</p>
        <ul>
          <li><strong>Necessary Cookies</strong> – These are essential cookies that enable core functions of the website. They help ensure a consistent user experience, such as remembering your login information or the data you’ve entered on the site.</li>
          <li><strong>Functionality Cookies</strong> – These cookies allow the website to recognize you when you return. They enable the Company to customize content for you, tailor the website to better suit your preferences, and remember your settings, such as language, region, or preferred font size.</li>
          <li><strong>Advertising Cookies</strong> – These cookies are used to remember the pages or products you have visited in order to present you with relevant products, services, or advertisements that match your interests. These cookies are stored on your device and track your browsing behavior, including visited pages and clicked links. Third-party cookies may also be used to gather information for delivering targeted online content and advertisements that align with your preferences.</li>
          <li><strong>Analytics and Performance Cookies</strong> – These cookies allow the Company to measure and analyze the performance of the website, such as the number of pages visited and user behavior patterns. The data collected helps the Company improve and optimize user experience.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h3 className="h5">Cookie Duration on Your Device</h3>
        <p>There are two types of cookies that may be stored:</p>
        <ul>
          <li><strong>Session Cookies</strong> – These are automatically deleted when you close your browser.</li>
          <li><strong>Persistent Cookies</strong> – These remain on your device until they expire or are manually deleted. Persistent cookies can store your preferences and interests, making your future visits more personalized and convenient.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h3 className="h5">Cookie Management</h3>
        <p>
          You can choose to set your preferences for each type of cookie, except for Strictly Necessary Cookies by using the “Cookie Settings” or through your web browser settings, such as blocking the installation of cookies on your device. Instructions for managing cookies can be found for the following browsers:
        </p>
        <ul>
          <li><a href="https://support.google.com/chrome/answer/95647?hl=th">Chrome</a></li>
          <li><a href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored">Firefox</a></li>
          <li><a href="https://support.microsoft.com/en-us/help/278835/how-to-delete-cookie-files-in-internet-explorer">Internet Explorer</a></li>
          <li><a href="https://support.microsoft.com/en-us/help/4468242/microsoft-edge-browsing-data-and-privacy">Microsoft Edge</a></li>
          <li><a href="https://support.apple.com/en-us/HT201265">Safari</a></li>
          <li><a href="https://support.apple.com/en-us/HT201265">Safari for iOS</a></li>
          <li><a href="https://support.google.com/chrome/answer/95647?hl=th">Chrome for Android</a></li>
          <li><a href="https://support.google.com/chrome/answer/95647?hl=th">Chrome for iOS</a></li>
        </ul>
        <p>
          Please note that disabling cookies may affect the functionality and efficiency of certain websites and may prevent you from using them as intended.
        </p>
      </section>

      <section className="mb-4">
        <h3 className="h5">Changes to the Cookie Policy</h3>
        <p>
          This Cookie Policy may be updated or modified from time to time to comply with applicable regulations. Therefore, we recommend that you regularly review this policy to stay informed of any changes.
        </p>
      </section>

      <section className="mb-4">
        <h3 className="h5">Contact Information</h3>
        <address>
          Cheese Digital Network Co., Ltd.<br />
          Address: 2521/55-56 Ladprao Road, Khongchaokhunsing Sub-district, Wangthonglang District, Bangkok 10310<br />
          Phone: 02-530 0185-6<br />
          Email: <a href="mailto:admin@cheesediginet.com">admin@cheesediginet.com</a>
        </address>
      </section>

      <section className="mt-5">
        <small className="text-muted">This Cookie Policy was last updated on October 1, 2025.</small>
      </section>
    </div>
  </div>
);
